import {Component} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslocoDirective} from '@jsverse/transloco';
import {environment} from '@environments/environment';
import {RouterLink} from '@angular/router';
import {RouteGenerator} from '@core/route-generator';
import {UI_ROUTES} from '@core/ui.routes';

@Component({
  selector: 'app-public-terms-publish',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    RouterLink
  ],
  templateUrl: './terms-publish.component.html',
  styleUrl: './terms-publish.component.scss'
})
export class TermsPublishComponent {
  public readonly domain = environment.domain;
  public readonly appName = environment.appName;

  public readonly routes = {
    terms: RouteGenerator.abs(UI_ROUTES.public.terms.home)
  };
}
